import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@core/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OfflineOrderManagementService } from './service/offlineordermanagement.service';
import { OfflineOrderHistoryComponent } from './offlineorderhistory/offlineorderhistory.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        NgbModule,
        FormsModule,
        NgbAccordionModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [OfflineOrderManagementService],
    declarations: [
        OfflineOrderHistoryComponent
    ]
})
export class OfflineOrderManagementModule { }